import React, { Fragment, Component } from 'react'
import { connect } from 'react-redux'

import BkFlowSteps from './stepper/BkFlowSteps'
import BkFlowNavigationPropertyDetails from './navigation/mobile/BkFlowNavigationPropertyDetails'

import '../../styles/css/components/structure/bk-flow-components.css'

// Import containers
import BkFlowRoomContain from '../../containers/rooms/BkFlowRoomContain'
import BkFlowPaymentContain from '../../containers/payment/BkFlowPaymentContain'
import BkFlowConfirmationContain from '../../containers/confirmation/BkFlowConfirmationContain'
import BkFlowLoyaltyBanner from '../loyalty/BkFlowLoyaltyBanner'
import BkFlowPreEnhancements from '../../components/enhancements/BkFlowPreEnhancements'
import BkFlowPartnersBenefitsBanner from '../partners/BkFlowPartnersBenefitsBanner'
import BkFlowStructuredSidebar from './sidebar/BkFlowStructuredSidebar'

import BkFlowLoader from '../elements/BkFlowLoader'

import setActiveStep from '../../actions/activeStepActions'
import renderHTML from 'react-render-html'

import yn from 'yn'
import _ from 'lodash'

function getStepContent(step) {
	switch (step) {
		case 0:
			return <BkFlowRoomContain />
		case 1:
			if (yn(process.env.REACT_APP_COMPONENT_PRE_ENHANCEMENTS)) {
				return <BkFlowPreEnhancements />
			} else {
				return <BkFlowPaymentContain />
			}
		case 2:
			if (yn(process.env.REACT_APP_COMPONENT_PRE_ENHANCEMENTS)) {
				return <BkFlowPaymentContain />
			} else {
				return <BkFlowConfirmationContain enhancements={ true } />
			}
		case 3:
			if (yn(process.env.REACT_APP_COMPONENT_POST_ENHANCEMENTS)) {
				return  <BkFlowConfirmationContain enchancements={ false } />
			} else {
				return  <BkFlowConfirmationContain enchancements={ true } />
			}
		default:
			return <BkFlowRoomContain />
	}
}

class BkFlowComponents extends Component {
	constructor(props) {
		super(props)
		this.state = {
		}
	}

	renderMaintenanceMessage() {
		const { availabilityData } = this.props

		if (
			!_.isEmpty(availabilityData) &&
			_.get(availabilityData, '[0][0].viewExtensions')
		) {
			const availabilityExtensions = availabilityData[0][0].viewExtensions,
						renderMessages = []

			if (
				availabilityExtensions &&
				!_.isEmpty(availabilityExtensions.bookingMessages)
			) {
				for (let messageKey in availabilityExtensions.bookingMessages) {
					renderMessages.push(
						<div
							className={`bk-flow-components__maintenance-message ${process.env.REACT_APP_COMPONENT_NOTIFICATION_MESSAGE_COMPONENT}`}
							key={ messageKey }
						>
							<div className="bk-flow-components__maintenance-message-content">
								{ availabilityExtensions.bookingMessages[messageKey].heading &&
									<h5>{ availabilityExtensions.bookingMessages[messageKey].heading }</h5>
								}

								{ availabilityExtensions.bookingMessages[messageKey].body &&
									renderHTML(availabilityExtensions.bookingMessages[messageKey].body)
								}
							</div>
						</div>
					)
				}

				return renderMessages
			} else {
				return null
			}
		}
	}

	componentDidMount() {
		const body = document.body

		if (yn(process.env.REACT_APP_COMPONENT_ENABLE_STRUCTURED_SIDEBAR)) {
			body.classList.add('inc-structured-sidebar')
			document.getElementById('bk-flow-components-content-container').classList.remove('u-container--full')
			document.getElementById('bk-flow-components-content-container').classList.add('inc-structured-sidebar')
		}
	}

	render() {
		const {
			activeStep,
			availabilityData,
			availabilityLoading,
			configData,
			configLoading,
			isUserLoggedIn,
			toggleEditModal,
			urlData
		} = this.props

		const body = document.body
		const hasMaintenanceMessage = _.get(availabilityData, '[0][0].viewExtensions.bookingMessages')

		if (hasMaintenanceMessage) {
			body.classList.add('inc-maintenance-banner')
		}

		let confirmationStep = 3

		if (!yn(process.env.REACT_APP_COMPONENT_PRE_ENHANCEMENTS)) {
			confirmationStep = 2
		}

		return (
			<div className="bk-flow-components">
				{ yn(process.env.REACT_APP_COMPONENT_ENABLE_STRUCTURED_SIDEBAR) &&
					process.env.REACT_APP_COMPONENT_NAVIGATION === 'basic' &&
					availabilityData &&
						<BkFlowNavigationPropertyDetails
							availabilityData={availabilityData}
							configData={configData}
							toggleEditModal={toggleEditModal}
							urlData={urlData}
						/>
				}

				{process.env.REACT_APP_COMPONENT_NOTIFICATION_MESSAGE_COMPONENT === 'navigation-full' && this.renderMaintenanceMessage()}

				{ yn(process.env.REACT_APP_COMPONENT_BANNER_STEPPER) &&
					!configLoading &&
					configData &&
					!availabilityLoading &&
						<BkFlowSteps />
				}
				{ yn(process.env.REACT_APP_COMPONENT_PARTNERS_BENEFITS_BANNER) && <BkFlowPartnersBenefitsBanner /> }

				<div className={`bk-flow-components__content row middle-xs center-xs${hasMaintenanceMessage ? ' include-maintenance' : ''}`}>
					<div
						id="bk-flow-components-content-container"
						className="component-container u-container u-container--full"
					>
						
						{ yn(process.env.REACT_APP_COMPONENT_ENABLE_LOYALTY_BANNER) && !isUserLoggedIn && <BkFlowLoyaltyBanner /> }
						
						{ process.env.REACT_APP_COMPONENT_NOTIFICATION_MESSAGE_COMPONENT === 'default' && this.renderMaintenanceMessage() }

						{ configData &&
							!availabilityLoading &&
							availabilityData ?
							<Fragment>
								{ getStepContent(activeStep) }
								{ yn(process.env.REACT_APP_COMPONENT_ENABLE_STRUCTURED_SIDEBAR) &&
									Number(activeStep) < Number(confirmationStep) &&
									<BkFlowStructuredSidebar
										toggleEditModal={() => toggleEditModal()}
									/>
								}
							</Fragment>
						:
							<BkFlowLoader
								parentClasses="initial-loader u-brand-loader row center-xs"
							/>
						}
					</div>
					<script id="CookieDeclaration" src="https://consent.cookiebot.com/0c245808-caef-4c46-a7b7-46902b4fd604/cd.js" type="text/javascript" async></script>
				</div>
			</div>
		)
	}
}

function mapStateToProps(state) {
	return {
		activeStep: state.activeStepData.activeStep,
		availabilityData: state.availabilityData.availability,
		availabilityLoading: state.availabilityData.loading,
		configData: state.configData.configuration,
		configLoading: state.configData.loading,
		isUserLoggedIn: state.profileUserData.user,
		urlData: state.availabilityData.urlData,
	}
}

const mapDispatchToProps = dispatch => ({
	handleStepperNavigation(index) {
		return (
			dispatch(setActiveStep(index))
		)
	}
})

export default connect(mapStateToProps, mapDispatchToProps)(BkFlowComponents)


// WEBPACK FOOTER //
// ./src/components/structure/BkFlowComponents.js